import { useState } from 'react';
import { Space } from 'antd';
import dayjs from 'dayjs';
import React from 'react';

import { Modal } from 'antd';
import { Box } from '@mui/material';
import Carousel from '@/components/UI/Carousel';

import MainButton from '@/components/UI/mobile/MainButton';
import type Message from '@/types/database/message';

import styles from './index.module.scss';

interface PersonalNoticeDetailProps {
  personalNoticeDetail: Message | null;
  updateIsShowPersonalNoticeDetail: (isShowDetail: boolean) => void;
  updatePersonalNoticeDetail: (newPersonalNoticeDetail: Message | null) => void;
}

const PersonalNoticeDetail = ({
  personalNoticeDetail,
  updateIsShowPersonalNoticeDetail,
  updatePersonalNoticeDetail,
}: PersonalNoticeDetailProps) => {
  console.log(personalNoticeDetail);
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState<boolean>(false);

  const handleMainButtonClick = () => {
    updateIsShowPersonalNoticeDetail(false);
    updatePersonalNoticeDetail(null);
  };
  const showPreviewImagePath = personalNoticeDetail?.files
    ? personalNoticeDetail.files.map((file) => file.response.png).flat()
    : [];

  const previewModalBodyStyle = {
    padding: 0,
    maxHeight: '95dvh',
  };

  return (
    <Box
      // className={styles.detailContainer}
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '1rem',
        '& > *:not(:last-of-type)': {
          marginBottom: '0.9rem',
        },
      }}
    >
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          overflowY: 'auto',
          '& > *:not(:last-of-type)': {
            marginBottom: '0.9rem',
          },
        }}
      >
        <Space direction="vertical" className={styles.detailContentContainer}>
          <Space className={styles.noticeTitleContainer}>
            <h5 className={styles.personalNoticeDetailLabel}>標題</h5>
            <p>
              {dayjs(personalNoticeDetail?.createdTime).format(
                'YYYY-MM-DD HH:mm:ss'
              )}
            </p>
          </Space>
          <p className={styles.personalNoticeDetailTitle}>
            {personalNoticeDetail?.title}
          </p>
          <h5 className={styles.personalNoticeDetailLabel}>內容</h5>
          <p>{personalNoticeDetail?.content}</p>
          {personalNoticeDetail?.files && (
            <>
              <h5 className={styles.personalNoticeDetailLabel}>檔案</h5>
              <Box
                sx={{
                  width: '100%',
                  overflow: 'hidden',
                  border: '1px solid #707070',
                  borderRadius: '0.4rem',
                  '& > img': {
                    width: '100%',
                    maxHeight: '100%',
                  },
                  '@media (orientation: landscape)': {
                    width: '50%',
                  },
                }}
              >
                {showPreviewImagePath.map((item, index) => (
                  <img
                    key={index}
                    src={item}
                    alt="圖片"
                    onClick={() => setIsPreviewModalOpen(true)}
                  />
                ))}
                <Modal
                  open={isPreviewModalOpen}
                  footer={null}
                  centered
                  bodyStyle={previewModalBodyStyle}
                  width="auto"
                  onCancel={() => setIsPreviewModalOpen(false)}
                >
                  <Carousel images={showPreviewImagePath} />
                </Modal>
              </Box>
            </>
          )}
        </Space>
        {/* <div className={styles.mainButtonContainer}></div> */}
      </Box>
      <MainButton onClick={handleMainButtonClick}>返回</MainButton>
    </Box>
  );
};

export default PersonalNoticeDetail;
